import clsx from 'clsx';
import { FC, useEffect } from 'react';
import Alert from '../Alert';

interface IBotAlert {
  show?: boolean;
  setShow: (show: boolean) => void;
  message: string;
  className?: string;
}

const BotAlert: FC<IBotAlert> = ({ show = false, setShow, message, className }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setShow(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [show, setShow]);

  return (
    <div
      className={clsx(
        'fixed z-[100] md:right-8 right-4 top-5',
        show ? ' block' : ' hidden',
        className,
      )}
    >
      <Alert
        label={
          <span
            className='flex items-center md:text-base text-s cursor-pointer'
            onClick={() => setShow(false)}
          >
            {message}
          </span>
        }
      />
    </div>
  );
};

export default BotAlert;
